import { InjectionToken } from '@angular/core';

import { NumberMaskConfig } from '../interfaces';

export const NUMBER_MASK_CONFIG = new InjectionToken<NumberMaskConfig>('number.mask.config');
